import React from 'react';
import styled from 'styled-components';
import PartnerPluginActivateMultiStep from './PartnerPluginActivateMultiStep';
import { useLanguageUtm } from '../Common';
import usePageTitle from '../Common/Hooks/usePageTitle';

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

export const hasSliideOrigin = () => {
  return window.location.search.includes('utm_campaign=sliide');
};

const PartnerNewpluginsdkActivate = () => {
  useLanguageUtm();
  usePageTitle();

  return <PartnerPluginActivateMultiStep />;
};

export default PartnerNewpluginsdkActivate;
